import React from 'react';
import { useSearchListContext } from '../useSearchListContext';
import SearchableListBody from './SearchableListBody';
import SearchableListGroup, { GroupItemData } from './SearchableListGroup';

type SearchableListResultProps<T> = {
  maxHeight?: number;
  stickyHeadersEnabled?: boolean;
  children: (item: T) => React.ReactNode;
};
const SearchableListResult = <T extends object>({
  maxHeight,
  stickyHeadersEnabled = false,
  children
}: SearchableListResultProps<T>) => {
  const { itemList, isGroupedList } = useSearchListContext();

  if (!isGroupedList) {
    return (
      <SearchableListBody maxHeight={maxHeight}>
        {itemList.map(item => children(item as T))}
      </SearchableListBody>
    );
  }

  const groupList = itemList as GroupItemData<T>[];

  return (
    <SearchableListBody maxHeight={maxHeight}>
      {groupList.map(groupData => {
        const firstWord = groupData.title
          .split(' ')
          .join('')
          .toLocaleLowerCase();

        return (
          <SearchableListGroup
            key={groupData.title}
            groupData={groupData}
            stickyHeadersEnabled={stickyHeadersEnabled}
            groupName={firstWord}
          >
            {children}
          </SearchableListGroup>
        );
      })}
    </SearchableListBody>
  );
};

export default SearchableListResult;
